export default "__VITE_ASSET__tI82agCK__"